/**
 * 全局record dom 操作组件
 */
var RECORD_DOM = {
    // 添加底层div的超出隐藏
    setRecordListContentHide() {
        var topDiv = document.getElementsByClassName('record-top-part')[0];
        var listDiv = document.getElementsByClassName('layout-record-list')[0];
        var letterDiv = document.getElementsByClassName('layout-letter-side-bar')[0];
        if(topDiv){
            topDiv.style = 'display: none;';
        }
        if(listDiv){
            listDiv.style = 'height: 0; overflow: hidden;';
        }
        if(letterDiv){
            letterDiv.style = 'display: none;';
        }
    },
    resetRecordListContentStyle() {
        var topDiv = document.getElementsByClassName('record-top-part')[0];
        var listDiv = document.getElementsByClassName('layout-record-list')[0];
        var scrollList = document.getElementById('RecordList');
        if(listDiv && topDiv) {
            setTimeout(() => {
                topDiv.style = '';
                listDiv.style.minHeight = (innerHeight-40) + 'px';
                listDiv.style.paddingTop = topDiv.clientHeight + 'px';
            }, 100);
        }
        if(scrollList) {
            scrollList.style.height = (innerHeight-topDiv.clientHeight-40) + 'px';
        }
    },
    updateRecordListStyle() {
        var topDiv = document.getElementsByClassName('record-top-part')[0];
        var listDiv = document.getElementById('RecordList');
        if(topDiv && listDiv){
            setTimeout(() => {
                topDiv.style = '';
                listDiv.style.height = (innerHeight-topDiv.clientHeight-40) + 'px';
            }, 100);
        }
    },
    resetRecordLetterSideBarStyle(type) {
        var topDiv = null;
            topDiv = type == 'record' ? document.getElementsByClassName('record-top-part')[0] : topDiv;
            topDiv = type == 'chooserecord' ? document.getElementsByClassName('record-choose-bar')[0] : topDiv;
        var letterDiv = document.getElementsByClassName('layout-letter-side-bar')[0];
        if(topDiv && letterDiv){
            // 子元素还没渲染出来，无法获取childElement的个数，所以延迟一些
            setTimeout(() => {
                letterDiv.style = 'top: ' + topDiv.clientHeight + 'px; line-height:' + innerHeight*0.6/letterDiv.childElementCount + 'px';
            }, 20);
        }
    },
    resetChooseRecordLetterSideBarStyle() {
        var topDiv = document.getElementsByClassName('record-choose-bar')[0];
        var letterDiv = document.getElementsByClassName('layout-letter-side-bar')[0];
        if(topDiv && letterDiv){
            // 子元素还没渲染出来，无法获取childElement的个数，所以延迟一些
            setTimeout(() => {
                letterDiv.style = 'top: ' + (topDiv.clientHeight + 40) + 'px; line-height:' + innerHeight*0.6/letterDiv.childElementCount + 'px';
            }, 20);
        }
    },
}

export {
    RECORD_DOM
}